import React from "react";
import Chip from "@mui/material/Chip"; // Assuming you are using Material-UI for Chip

const RenderStatusMessage = ({ status }) => {
  switch (status?.toLowerCase()) {
    case "queued":
    case "pending":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#ffb300", color: "#3c2f00" }} // Amber background, dark text for contrast
        />
      );
    case "sent":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#0288d1", color: "#ffffff" }} // Blue background, white text
        />
      );
    case "delivered":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#1976d2", color: "#ffffff" }} // Darker blue, white text
        />
      );
    case "read":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#2e7d32", color: "#ffffff" }} // Green, white text
        />
      );
    case "failed":
    case "undelivered":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#d32f2f", color: "#ffffff" }} // Red, white text
        />
      );
    case "accepted":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#388e3c", color: "#ffffff" }} // Slightly lighter green, white text
        />
      );
    case "deleted":
      return (
        <Chip
          label={status}
          size="small"
          sx={{ bgcolor: "#757575", color: "#ffffff" }} // Grey, white text
        />
      );
    default:
      return (
        <Chip
          label={status || "Unknown"}
          size="small"
          sx={{ bgcolor: "#9e9e9e", color: "#ffffff" }} // Neutral grey, white text
        />
      );
  }
};

export default RenderStatusMessage;
